import React, { ReactElement } from 'react';
import { Typography } from 'antd';
import { VizState } from '@cubejs-client/react';
import { Chart } from '@threatadvisor/react-components';
import { getPriorityScaleColors } from '../../utils';

export type DetectionCasesByPriorityProps = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
};

export default function DetectionCasesByPriority(
  props: DetectionCasesByPriorityProps
): ReactElement {
  const { clientUid, reportStart, reportEnd } = props;

  const getDetectionCountByPriority = (): VizState => {
    return {
      chartType: 'bar',
      pivotConfig: {
        x: ['detection_case.priority'],
        y: ['measures'],
        fillMissingDates: true
        //"joinDateRange": false
      },
      query: {
        measures: ['detection_case.count'],
        dimensions: ['detection_case.priority'],
        timeDimensions: [
          {
            dimension: 'detection_case.createdDate',
            dateRange: [reportStart, reportEnd]
          }
        ],
        order: {
          'detection_case.priority': 'asc'
        },
        filters: [
          {
            member: 'detection_case.clientUid',
            operator: 'equals',
            values: [clientUid]
          },
          {
            member: 'detection_case.priority',
            operator: 'notEquals',
            values: ['P5', '5']
          }
        ]
      }
    };
  };

  return (
    <>
      <h2 className="text-uppercase">Detection Cases By Priority</h2>

      <figure>
        {' '}
        <Chart
          hideCubeName
          useGridTable
          showZeroCategories={['P1', 'P2', 'P3', 'P4']}
          chartConfig={{
            ...getPriorityScaleColors()
          }}
          config={getDetectionCountByPriority()}
        />
        <figcaption>
          <Typography.Text type="secondary">
            Shows total cases created by priority level.
          </Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
